// store/rootReducer.ts
import { combineReducers } from '@reduxjs/toolkit';

import authReducer from '@/store/slices/auth/authSlice';
import orginzationReducer from '@/store/slices/organization/organizationSlice'
import UIReducer from '@/store/slices/ui/UISlice';
import administratorsReducer from '@/store/slices/administratorsForm/administratorsFormSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  organization: orginzationReducer,
  ui: UIReducer,
  administrators: administratorsReducer,
  // Add other reducers here as your app grows
});

// Infer the `RootState` type from the root reducer
export type RootState = ReturnType<typeof rootReducer>;
